import React from 'react'
import styled from 'styled-components'

import Table from 'components/Luxkit/Tables/Table'
import TableBody from 'components/Luxkit/Tables/TableBody'
import TableBodyCell from 'components/Luxkit/Tables/TableBodyCell'
import TableBodyRow from 'components/Luxkit/Tables/TableBodyRow'
import TableHeader from 'components/Luxkit/Tables/TableHeader'
import TableHeaderCell from 'components/Luxkit/Tables/TableHeaderCell'
import TableHeaderRow from 'components/Luxkit/Tables/TableHeaderRow'

import Group from 'components/utils/Group'
import FormatCurrency from 'components/Common/FormatCurrency'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'

const TableBodyRowTotal = styled(TableBodyRow)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

interface Props {
  oldPrice: number;
  newPrice: number;
  oldPropertyFees: number;
  newPropertyFees: number;
  className?: string;
}

function PriceChangeViewV2(props: Props) {
  const {
    oldPrice,
    newPrice,
    oldPropertyFees,
    newPropertyFees,
    className,
  } = props

  return (
    <Group direction="vertical" gap={16} className={className}>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell minWidth={96}></TableHeaderCell>
            <TableHeaderCell minWidth={96}>
              <BodyText variant="medium" colour="neutral-three">Before</BodyText>
            </TableHeaderCell>
            <TableHeaderCell minWidth={96}>
              <BodyText variant="medium">Now</BodyText>
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {oldPropertyFees !== newPropertyFees && (
            <>
              <TableBodyRow>
                <TableBodyCell>
                  <BodyText variant="medium">Pay Now</BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium" colour="neutral-three" strikeThrough={newPrice !== oldPrice}>
                    <FormatCurrency value={oldPrice} />
                  </BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium">
                    <FormatCurrency value={newPrice} />
                  </BodyText>
                </TableBodyCell>
              </TableBodyRow>
              <TableBodyRow>
                <TableBodyCell>
                  <BodyText variant="medium">Pay at hotel</BodyText>
                  <BodyText variant="small">Local Tax</BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium" colour="neutral-three" strikeThrough>
                    <FormatCurrency value={oldPropertyFees} />
                  </BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium">
                    <FormatCurrency value={newPropertyFees} />
                  </BodyText>
                </TableBodyCell>
              </TableBodyRow>
            </>
          )}
          <TableBodyRowTotal>
            <TableBodyCell>
              <BodyText variant="medium" weight="semi-bold">Total</BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="medium" weight="semi-bold" colour="neutral-three" strikeThrough>
                <FormatCurrency value={oldPrice + oldPropertyFees} />
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="medium" weight="semi-bold">
                <FormatCurrency value={newPrice + newPropertyFees} />
              </BodyText>
            </TableBodyCell>
          </TableBodyRowTotal>
        </TableBody>
      </Table>
      {oldPropertyFees !== newPropertyFees && <BodyTextBlock variant="medium">Property fees are estimated by Luxury Escapes based on information provided by the property and are subject to change.</BodyTextBlock>}
    </Group>
  )
}

export default PriceChangeViewV2
